import { Phone } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

const SERVICES = [
  { name: "Emergency", detail: "Police, ambulance or fire", number: "000", href: "tel:000" },
  { name: "Lifeline", detail: "24/7 crisis support and suicide prevention", number: "13 11 14", href: "tel:131114" },
  { name: "Beyond Blue", detail: "Mental health support, 24/7", number: "1300 22 4636", href: "tel:1300224636" },
  { name: "Suicide Call Back Service", detail: "24/7 counselling for people at risk", number: "1300 659 467", href: "tel:1300659467" },
  { name: "Open Arms", detail: "Veterans and defence families, 24/7", number: "1800 011 046", href: "tel:1800011046" },
  { name: "1800RESPECT", detail: "Family, domestic and sexual violence support, 24/7", number: "1800 737 732", href: "tel:1800737732" },
  { name: "13YARN", detail: "Crisis support for Aboriginal and Torres Strait Islander people", number: "13 92 76", href: "tel:139276" },
  { name: "Kids Helpline", detail: "For young people aged 5–25, 24/7", number: "1800 55 1800", href: "tel:1800551800" },
];

export default function CrisisSupport() {
  return (
    <main data-testid="crisis-page">
      <section className="bg-euca-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
          <SectionHeading
            dark
            eyebrow="Emergency & Crisis Support"
            title="If you need help right now"
            lead="Eucalypt Therapy is not a crisis service. If you or someone you know needs immediate support, please use the services below — they are free, confidential and available now."
          />
        </div>
      </section>
      <section className="bg-euca-mist">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
          <div className="grid gap-6 sm:grid-cols-2" data-testid="crisis-services-grid">
            {SERVICES.map((s, i) => (
              <Reveal key={s.name} delay={(i % 2) * 0.06}>
                <a
                  href={s.href}
                  data-testid={`crisis-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="group flex h-full items-center justify-between gap-4 rounded-2xl border border-euca-line bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-euca-sage hover:shadow-lg"
                >
                  <div>
                    <h2 className="font-serif text-2xl font-medium text-euca-dark">{s.name}</h2>
                    <p className="mt-1 text-sm text-mutedsoft">{s.detail}</p>
                    <p className="mt-3 text-lg font-semibold text-euca">{s.number}</p>
                  </div>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-euca-badge text-euca transition-colors duration-300 group-hover:bg-euca group-hover:text-white">
                    <Phone className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-12 text-center text-base text-mutedsoft">
              For non-urgent appointments, call Eucalypt Therapy on{" "}
              <a href="tel:+61417508502" className="font-semibold text-euca hover:underline" data-testid="crisis-practice-phone">0417 508 502</a>.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
